<template>
  <div class="card review-form">

    <div class="fixed submitted-modal display show">
      <div class="table-center">
        <div class="cell-center">
          <div class="submitted">
            <div class="checkmark-circle">
              <div class="background"></div>
              <div class="checkmark draw submitting start"></div>
            </div>
            <h2 class="margin-b font-fix">{{ $t('review.successBooked') }}</h2>
            <p class="margin-b font-fix">{{ $t('review.tyRsvp') }} </p>
            <p class="margin-b font-fix">{{ thankyou.reservationText }}: <strong>{{ thankyou.reservationNumber }}</strong></p>
            <p class="margin-b font-fix">{{ $t('review.weSentEmail') }} <strong><i>{{userEmail}}</i></strong>.</p>
            <p class="margin-b font-fix">
              {{ $t('review.safelyClose') }}
              <a @click="widgetReturn">{{ $t('review.thisLink') }}</a>.
            </p>
            <transition name="slide-down">
              <div class="payment-error" v-show="thankyou.roundTripPaymentError">
                <i class="fas fa-exclamation-triangle fa-lg"></i>
                <span>
                  {{ $t('review.unfortunately') }}
                </span>
              </div>
            </transition>

            <div class="signup-box"> <!-- v-if="!userSubscribe" -->
              <div v-if="subscribeSuccess" class="success">
                <p>{{ $t('review.subscribed') }}</p>
              </div>
              <div v-else>
                <p class="margin-b font-fix">{{ $t('review.subscribeMailing') }}</p>
                <a :class="{'op-btn btn-md btn-success':true, 'disabled':subscribeLoading}" @click="subscribe">
                  <span v-if="subscribeLoading">
                    {{ $t('common.loading') }} <i class="fas fa-spinner fa-spin"></i>
                  </span>
                  <span v-else>{{ $t('review.subscribeNow') }}</span>
                </a>
                <p v-if="!!subscribeError" class="error">{{subscribeError}}</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment-timezone'

export default {
  name: 'thankyou',
  props: [ 'user', 'flash', 'leg1', 'leg2' ],
  data () {
    return {
      submitting: true,
      showSubmittingModal: false,
      submitError: '',
      showSubmitError: false,
      // reservationText: '',
      // reservationNumber: '',
      // roundTripPaymentError: false,
      subscribeLoading: false,
      subscribeSuccess: false,
      subscribeError: ''
    }
  },
  computed: {
    thankyou () { return this.$store.state.thankyou },
    selectedCard () { return this.$store.state.selectedCard },
    subtotal () {
      if (this.mtech.enabled) {
        let rsvp = this.$store.state.reservation.leg1
        if (rsvp.selectedService) {
          let service = this.mtech.leg1.services[rsvp.selectedService]
          return service.price.breakdown[0].amount + service.price.addMarkup
        }
        return 0
      }

      let rsvp = this.$store.state.reservation
      let leg1 = rsvp.leg1
      let leg2 = rsvp.leg2
      let result = 0
      if (leg1.selectedService) {
        let serviceData = leg1.services[leg1.selectedService]
        let servicePricing = serviceData.prices[leg1.passenger - 1]
        if (rsvp.isRoundtrip) servicePricing = serviceData.roundtrip[leg1.passenger - 1]
        result = servicePricing.price
      }
      if (rsvp.isRoundtrip && leg2.selectedService) {
        let serviceData = leg2.services[leg2.selectedService]
        let servicePricing = serviceData.roundtrip[leg2.passenger - 1]
        result += servicePricing.price
      }
      return result
    },
    total () {
      if (this.mtech.enabled) {
        let total = this.subtotal + this.tip
        let rsvp = this.$store.state.reservation.leg1
        if (rsvp.selectedService) {
          let breakdown = this.mtech.leg1.services[rsvp.selectedService].price.breakdown
          for (let i = 1; i < breakdown.length; i++) {
            total += breakdown[i].amount
          }
        }
        total = total - this.$store.state.credits
        return total >= 0 ? total : 0
      }

      // let total = this.$store.state.fare +
      let total = this.subtotal +
        this.$store.state.tip.amount +
        this.meetAndGreetFee +
        this.airportFee +
        this.gasFee +
        this.travelInsurance -
        this.$store.state.credits
      return total >= 0 ? total : 0
    },
    bidRequest () { return this.$store.state.bidRequest },
    tip () { return this.$store.state.tip.amount },
    credits () { return this.$store.state.credits },
    backLink () { return this.$store.state.progressSteps[0].link.split('#')[0] },
    meetAndGreetFee () {
      let result = 0
      let rsvp = this.$store.state.reservation
      let leg1 = rsvp.leg1
      let leg2 = rsvp.leg2
      if (leg1.isAirportPickup) {
        result += parseInt(leg1.pickupFee)
      }
      if (rsvp.isRoundtrip && leg2.isAirportPickup) {
        result += parseInt(leg2.pickupFee)
      }
      return result
    },
    airportFee () {
      let result = 0
      if (this.leg1.airportFee) {
        result += parseFloat(this.leg1.airportFee)
      }
      if (this.leg2) {
        if ((Object.keys(this.leg2).length > 0) && this.leg2.airportFee) {
          result += parseFloat(this.leg2.airportFee)
        }
      }
      return result
    },
    gasFee () {
      if (this.mtech.enabled) return 0

      let result = 0
      let rsvp = this.$store.state.reservation
      if (rsvp.leg1.selectedService && rsvp.leg1.services[rsvp.leg1.selectedService].gasFee) {
        result += parseFloat(rsvp.leg1.services[rsvp.leg1.selectedService].gasFee)
      }
      if (rsvp.isRoundtrip && rsvp.leg2.selectedService && rsvp.leg2.services[rsvp.leg2.selectedService].gasFee) {
        result += parseFloat(rsvp.leg2.services[rsvp.leg2.selectedService].gasFee)
      }
      return result
    },
    travelInsurance () {
      if (this.mtech.enabled) return 0

      let rsvp = this.$store.state.reservation
      let total = 0

      if (rsvp.leg1.selectedService) {
        total = parseFloat(rsvp.leg1.services[rsvp.leg1.selectedService].travelInsurance)
      }

      if (rsvp.isRoundtrip && rsvp.leg2.selectedService) {
        total += parseFloat(rsvp.leg2.services[rsvp.leg2.selectedService].travelInsurance)
      }
      return total
    },
    userSubscribe () { return this.$store.state.user.emailSubscribed },
    termsOfUseLink () {
      let link = ''
      for (let brand in CONFIG.Brands) {
        if (CONFIG.Brands[brand].id === this.$store.state.brandId) {
          link = '/' + CONFIG.Brands[brand].termsOfServiceLink
        }
      }
      return link
    },
    isCorporate () { return this.$store.state.user.isCorporate },
    userEmail () { return this.$store.state.user.email },
    isRoundtrip () { return this.$store.state.reservation.isRoundtrip },
    charter () { return this.$store.state.reservation.charter },
    optin () { return this.$store.state.reservation.optin },
    mtech () { return this.$store.state.reservation.mtech },
    _lang () { return this.$i18n.locale },
    discountCode () { return this.$store.state.discountCode },
    brandLabel () {
      let brand = Object.values(CONFIG.Brands).find(x => x.id === this.$store.state.brandId)
      return brand ? brand.label : 'Door2Door'
    }
  },
  methods: {
    buildPayload (leg, currentLeg) {
      if (Object.keys(leg).length <= 0) return null
      let flightNumber = ''
      let flightName = ''
      let flightNumberDropoff = ''
      let flightNameDropoff = ''
      let rsvp = this.$store.state.reservation[currentLeg]
      if (rsvp.isAirportPickup) {
        flightNumber = leg.flightNumber
        flightName = leg.flightName
      }
      if (!rsvp.isAirportPickup && rsvp.isAirportDropoff) {
        flightNumberDropoff = leg.flightNumber
        flightNameDropoff = leg.flightName
      }
      let pickupTime = moment.tz(leg.pickupTimestamp, 'X', rsvp.timezone || 'America/Los_Angeles').format('X')
      // if (this.mtech.enabled) {
      //   pickupTime = moment(leg.pickupTimestamp, 'X').tz(rsvp.timezone || 'America/Los_Angeles').format('X')
      // }

      let gasFee = 0
      if (!this.mtech.enabled) {
        gasFee = rsvp.services[rsvp.selectedService].gasFee
      }
      let legData = {
        pickup: {
          address1: leg.address1,
          address2: leg.address2,
          city: leg.city,
          state: leg.state,
          zip: leg.zip,
          lat: leg.pickUpLocation.split(',')[0].trim(),
          lng: leg.pickUpLocation.split(',')[1].trim(),
          title: leg.title,
          geofenceId: leg.pickupGeofenceId
        },
        dropoff: {
          address1: leg.dropOffAddress1,
          address2: leg.dropOffAddress2,
          city: leg.dropOffCity,
          state: leg.dropOffState,
          zip: leg.dropOffZip,
          lat: leg.dropOffLocation.split(',')[0].trim(),
          lng: leg.dropOffLocation.split(',')[1].trim(),
          title: leg.dropOffTitle,
          geofenceId: leg.dropoffGeofenceId
        },
        pickupTime: pickupTime,
        passengers: leg.passengers,
        luggage: leg.luggage,
        amount: leg.amount,
        originalPrice: leg.originalPrice,
        airportFee: leg.airportFee,
        gasFee: gasFee,
        flightNumber: flightNumber,
        flightName: flightName,
        dropoffFlightName: flightNameDropoff,
        dropoffFlightNumber: flightNumberDropoff,
        asap: false,
        etaInSec: leg.etaInSec,
        serviceTypeId: leg.serviceID,
        serviceType: leg.serviceType,
        pickupType: rsvp.pickupType,
        pickupFee: rsvp.pickupFee,
        distance: leg.distance,
        notes: this.$store.state.driverNotes[currentLeg]
      }
      let extraStops = this.$store.state.reservation.extraStop[currentLeg]
      if (extraStops.length) {
        extraStops.forEach(stop => {
          if (!legData.extraStops) {
            legData.extraStops = []
          }
          legData.extraStops.push({
            address1: stop.location.address1,
            address2: stop.location.address2,
            city: stop.location.city,
            state: stop.location.state,
            zip: stop.location.zip,
            lat: stop.location.lat,
            lng: stop.location.lng,
            title: stop.location.title
          })
        })
      }
      if (!CONFIG.useOldQuatation && !this.mtech.enabled) {
        delete legData.serviceType
        legData.serviceTypeId = rsvp.services[leg.serviceType].id
        legData.travelInsurance = rsvp.services[rsvp.selectedService].travelInsurance
      }
      if (!this.$store.state.isManualTip) {
        legData.tip = this.$store.state.tip[currentLeg]
      }

      if (this.optin[currentLeg].enabled) {
        let pricing = this.isRoundtrip ? 'roundtrip' : 'prices'
        let origPrice = rsvp.services[rsvp.selectedService][pricing][(leg.passengers || 1) - 1].price
        let percent = rsvp.services[rsvp.selectedService].optinPercent / 100
        percent = parseFloat((1 - percent).toFixed(2))
        legData.optinShared = {
          serviceTypeId: rsvp.services[leg.serviceType].id,
          amount: parseFloat((origPrice * percent).toFixed(2))
        }
      }

      if (this.mtech.enabled) {
        legData.serviceTypeId = null
        legData.mtechServiceType = this.mtech[currentLeg].services[rsvp.selectedService].product
        legData.pickupTime = moment.tz(this.mtech[currentLeg].pickupDate, 'MM/DD/YYYY hh:mmA', rsvp.timezone).format('X')
        legData.flightTime = moment.tz(rsvp.flightDate, 'MM/DD/YYYY hh:mmA', rsvp.timezone).format('X')
        legData.flightAirline = rsvp.airlineCode
        legData.flightDomestic = this.$store.state.reservation.suggestedTime[currentLeg].isDomestic
        // if (this.mtech[currentLeg].services[rsvp.selectedService].pickupTimes.length) {
        //   legData.pickupTime = this.mtech[currentLeg].services[rsvp.selectedService].pickupTimes[0].unix
        // }

        legData.mtechPrice = this.mtech[currentLeg].services[rsvp.selectedService].price.amount.toFixed(2)
        let priceBeforeCredits = this.subtotal
        if (rsvp.selectedService) {
          let breakdown = this.mtech.leg1.services[rsvp.selectedService].price.breakdown
          for (let i = 1; i < breakdown.length; i++) {
            priceBeforeCredits += breakdown[i].amount
          }
        }
        legData.amount = priceBeforeCredits.toFixed(2)
        legData.originalPrice = priceBeforeCredits.toFixed(2)
      }

      if (this.discountCode.id && this.discountCode.amount) {
        let pricing = this.isRoundtrip ? 'roundtrip' : 'prices'
        legData.amount = rsvp.services[rsvp.selectedService][pricing][rsvp.passenger - 1].price
      }

      return legData
    },
    submitRequest () {
      if (/*CONFIG.Env == 'production' &&*/ window.gtag) { // eslint-disable-line
        gtag('event', `Review_Payment`) // eslint-disable-line
      }
      if (this.$store.state.reservation.leg1.isAsap) {
        this.$store.commit('reservation/setAsapModal', true)
        return
      }

      let brands = Object.keys(CONFIG.Brands)
      let brandId = this.$store.state.brandId
      let index = Object.values(CONFIG.Brands).findIndex(x => x.id === brandId)
      let isHudson = CONFIG.Brands[brands[index]].code === 'pts'
      // let isHudson = true

      this.submitting = true
      this.showSubmittingModal = true
      let guestInfo = this.$store.state.guestInfo
      let guestMobile = guestInfo.countryCode + guestInfo.mobile
      if (guestMobile) { guestMobile = '+' + guestMobile }

      let cardId = this.selectedCard.id
      let storeUser = this.$store.state.user
      if (storeUser.isCorporate && storeUser.isDirectBilling) {
        cardId = null
      }

      let guest = guestInfo.proxy ? {
        firstName: guestInfo.firstName,
        lastName: guestInfo.lastName,
        mobile: guestMobile,
        countryCode: guestInfo.countryCode,
        nationalNumber: guestInfo.mobile
      } : null
      if (this.isCorporate) {
        guest = {
          firstName: guestInfo.firstName,
          lastName: guestInfo.lastName,
          mobile: guestMobile,
          countryCode: guestInfo.countryCode,
          nationalNumber: guestInfo.mobile
        }
      }

      if (this.charter.enabled) {
        let charterParam = {
          brandId: this.$store.state.brandId,
          deviceType: 'ww',
          guest: guest,
          hudson: false,
          legs: [
            this.buildPayload(this.bidRequest.leg1, 'leg1'),
            null
          ],
          payment: {
            cardID: cardId,
            tip: this.tip,
            total: this.total,
            fare: this.$store.state.fare,
            pickupFee: this.meetAndGreetFee,
            promo: this.credits
          },
          wheelChair: this.$store.state.user.ada.wheelChairLift ? 1 : 0,
          serviceDog: this.$store.state.user.ada.serviceDog ? 1 : 0,
          token: this.$store.state.user.token,
          source: 'C',
          isCharter: true
        }
        let startDate = moment(this.charter.startDate, 'MM/DD/YYYY hh:mmA')
        let endDate = moment(this.charter.endDate, 'MM/DD/YYYY hh:mmA')
        charterParam.legs[0].pickupTime = startDate.format('X')
        charterParam.legs[0].etaInSec = endDate.diff(startDate, 'seconds')
        charterParam.legs[0].airportGeofenceId = this.$store.state.reservation.leg1.pickup.geofenceType === 'airport' ? this.charter.airportGeoId : null
        delete charterParam.legs[0].dropoff
        // delete charterParam.legs[0].passengers
        // delete charterParam.legs[0].luggage
        delete charterParam.legs[0].distance
        delete charterParam.legs[0].dropoffFlightName
        delete charterParam.legs[0].dropoffFlightNumber
        delete charterParam.legs[0].travelInsurance
        this.$root.$emit('submitCharterRsvp', charterParam)
        return
      }

      this.$root.$emit('submitRsvp', {
        guest: guest,
        leg1: this.buildPayload(this.bidRequest.leg1, 'leg1'),
        leg2: this.buildPayload(this.bidRequest.leg2, 'leg2'),
        payment: {
          cardID: cardId,
          tip: this.tip,
          total: this.total.toFixed(2),
          fare: this.total.toFixed(2),
          pickupFee: this.meetAndGreetFee,
          promo: this.credits
        },
        wheelChair: this.$store.state.user.ada.wheelChairLift ? 1 : 0,
        serviceDog: this.$store.state.user.ada.serviceDog ? 1 : 0,
        hudson: isHudson,
        isCorporate: this.isCorporate,
        token: this.$store.state.user.token,
        quoteId: this.$store.state.reservation.quoteId,
        isMtech: this.mtech.enabled,
        discountCodeAmount: this.discountCode.amount,
        discountCodeId: this.discountCode.id
      })
    },
    addZero (val) {
      return parseFloat(val).toFixed(2)
    },
    widgetReturn () { window.location.href = `${window.location.origin}${window.location.pathname}` },
    subscribe () {
      let self = this
      let user = self.$store.state.user
      if (self.subscribeLoading) { return }
      self.subscribeLoading = true
      self.subscribeError = ''
      self.$sdk.post2('https://emaildashboard-api.opoli.com/1.1/email/subscription', {
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        brandId: self.brandLabel
      }, res => {
        self.subscribeLoading = false
        if (res.error) {
          self.subscribeError = res.error.message
          self.subscribeSuccess = false
          return
        }
        self.subscribeSuccess = true
      })
    }
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/scss/CreditCardIcons.scss";
@import "../../assets/scss/Review/ReviewDetails.scss";
@import "../../assets/scss/Review/ThankYou.scss";
h2{ font-size: 1.5em!important; }
a { cursor: pointer; }
.clear{ clear:both; }

.payment-error{
  padding: 10px;
  background: #ef8f1a;
  color: #fff;
  font-style: italic;
  max-width: 750px;
  margin: 0 auto;
  border-radius: 3px;
  -webkit-box-shadow: 2px 2px 2px rgba(0,0,0,.3);
  box-shadow: 2px 2px 2px rgba(0,0,0,.3);

  i{
    margin-right: 10px;
    margin-left: 5px;
  }
}

.signup-box{
  border: 1px solid #2eb150;
  width: 100%;
  max-width: 580px;
  margin: 40px auto 0;
  padding: 20px;
  background: #f1fff4;

  p{
    line-height: 145%;
    font-size: 15px;
    font-weight: 600;
    color: #555;
  }
  .op-btn{ padding: 12px 40px; }
  .error{
    margin: 10px 0 0;
    color: #f00;
  }
  .success p { margin: 0; }
}

.submitted-modal{
  overflow: auto;
}
.font-fix{
  font-family: "Montserrat", sans-serif!important;

  &h2{
    font-weight: 600;
  }
}

.terms-box{
  font-size: 14px;
  text-align: center;
  margin-top: 10px;
}

.margin-b{
  margin-bottom: 15px!important;
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: translateY(-30px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// index.vue?12304a38